import { RouteProp } from '@react-navigation/native';
import React from 'react';
import { ProfilesTabParamList, useProfilesTabNavigation } from '../../../../../utils/appNavigationNames';
import NotesList from '../../../../shared/Notes/NotesList';

export type ProfileNotesScreenOwnProps = {};

export type ProfileNotesScreenProps = ProfileNotesScreenOwnProps & {
    route: RouteProp<ProfilesTabParamList, 'profile-notes'>;
};

const ProfileNotesScreenScreen: React.FC<ProfileNotesScreenProps> = (props) => {
    const navigation = useProfilesTabNavigation();

    return (
        <NotesList
            noteQueryArgs={{ medicalProfileId: props.route.params.profileId, entityType: 'medical-profile' }}
            onAddNote={(noteQueryArgs) => {
                navigation.navigate('add-note', noteQueryArgs);
            }}
            onViewDetails={(note) => {
                navigation.navigate('note', {
                    noteId: note.noteId,
                    noteEntityType: note.entityType,
                    profileId: props.route.params.profileId,
                });
            }}
        />
    );
};

export default React.memo(ProfileNotesScreenScreen);
